// PIT-TASK-2027-000174: make the navbar language picker work for logged-in
// users, not just guests.
//
// Frappe core (frappe/website/js/website.js -> show_language_picker) reveals
// the navbar language switcher ONLY when frappe.session.user === "Guest".
// The choice is persisted in the preferred_language cookie, which the server
// ignores for logged-in sessions (User.language wins there, see
// frappe.translate.get_language). On this B2B portal nearly every visitor is
// logged in, so the Website Setting show_language_picker appeared to "do
// nothing".
//
// This module replaces frappe.show_language_picker. It evaluates before DOM
// ready (plain script tag in <head>, loaded after frappe-web.bundle.js), so
// core's frappe.ready callback picks up THIS function instead of core's own.
// Behaviour for guests is unchanged (cookie + reload); for logged-in users
// the selection is additionally persisted on the User document via
// webshop.scripts.utils.set_website_language.
//
// ADJUSTMENT: the language list comes from
// webshop.scripts.utils.get_website_picker_languages, which restricts the shown languages
// to the Webshop Settings "Language Picker Languages" table when configured there
// (PIT-TASK-2027-000174 adjustment); empty table = all enabled languages.

frappe.show_language_picker = function () {
	if (!window.show_language_picker) {
		return;
	}
	frappe
		.call("webshop.scripts.utils.get_website_picker_languages")
		.then((res) => {
			const language_list = res.message || [];
			const language_codes = [];
			const language_switcher = $("#language-switcher .form-control");
			if (!language_switcher.length || !language_list.length) {
				return;
			}
			language_list.forEach((language_doc) => {
				language_codes.push(language_doc.language_code);
				// PIT-TASK-2027-000380: show only the language code as the visible
				// label (uppercase, primary subtag before "-": de -> DE, en -> EN,
				// it -> IT, sr-CS -> SR). The option VALUE keeps the full
				// language_code so set_website_language stays valid.
				const short_label = String(language_doc.language_code)
					.split("-")[0]
					.toUpperCase();
				language_switcher.append(
					$("<option></option>")
						.attr("value", language_doc.language_code)
						.attr("title", language_doc.language_name)
						.text(short_label)
				);
			});
			$("#language-switcher").removeClass("hide");
			// document.documentElement.lang is the server-rendered language
			// (<html lang="{{ boot.lang }}">) — the correct fallback for
			// logged-in users (their User.language), where no cookie exists.
			let language =
				frappe.get_cookie("preferred_language") ||
				document.documentElement.lang ||
				(language_codes.includes(navigator.language) ? navigator.language : "en");
			// The user's current language may be outside the restricted list —
			// fall back to the first offered language so the select is never
			// left without a selection.
			if (!language_codes.includes(language)) {
				language = language_codes[0];
			}
			language_switcher.val(language);
			document.documentElement.lang = language;
			language_switcher.change(() => {
				const lang = language_switcher.val();
				document.cookie = `preferred_language=${lang}; path=/; SameSite=Lax`;
				if (frappe.session.user && frappe.session.user !== "Guest") {
					frappe
						.call("webshop.scripts.utils.set_website_language", {
							language: lang,
						})
						.then(() => window.location.reload());
				} else {
					window.location.reload();
				}
			});
		});
};
